import AddMetaDescription from 'components/AddMetaDescription';
import { usePageViewTracker } from 'context/PageViewTracker';
import React from 'react';

const PageMeta = ({
  url,
  title,
  description,
  ogImageUrl,
  pageUrl,
  structurDataStringify,
  useOembed,
  nextPageUrl,
  previousPageUrl,
  ldJson
}: {
  url: string;
  title: string;
  description: string;
  ogImageUrl?: string;
  pageUrl?: string;
  structurDataStringify?: string;
  useOembed?: boolean;
  nextPageUrl?: string | null;
  previousPageUrl?: string | null;
  ldJson?: string;
}) => {
  const { deepLink } = usePageViewTracker();

  return (
    <AddMetaDescription>
      <title>{title}</title>
      <meta name="description" content={`${description}`} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={`${description}`} />
      <meta
        property="og:image"
        content={
          ogImageUrl ||
          'https://insighttimer.com/static/media/logo-bowl.8c14da94.png'
        }
      />
      <meta property="og:image:width" content="200" />
      <meta property="og:image:height" content="200" />
      <meta property="og:url" content={pageUrl || url} />
      <link rel="canonical" href={url} />
      {ldJson && <script type="application/ld+json">{ldJson}</script>}
      {deepLink != null && (
        <meta name="branch:deeplink:$deeplink" content={deepLink} />
      )}
      {deepLink != null && (
        <meta name="branch:deeplink:$deeplink_v2" content={deepLink} />
      )}
      {structurDataStringify && (
        <script type="application/ld+json">{structurDataStringify}</script>
      )}
      {useOembed && (
        <link
          rel="alternate"
          type="application/json+oembed"
          href={`https://widgets.insighttimer.com/services/oembed?url=${url}`}
          title={title}
        />
      )}
      {nextPageUrl && <link rel="next" href={nextPageUrl} />}
      {previousPageUrl && <link rel="prev" href={previousPageUrl} />}
    </AddMetaDescription>
  );
};

export default PageMeta;
